import { AddCircleOutlineOutlined } from "@mui/icons-material";
import Delete from "@mui/icons-material/Delete";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { format, utcToZonedTime } from "date-fns-tz";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import { useState } from "react";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { DedicatedDeliveryAgent } from "../../../../app/api/dedicatedDelivery/DedicatedDeliveryAgent";
import { FdpAgent } from "../../../../app/api/fdp/FdpAgent";
import { AddRtsAgent } from "../../../../app/api/rts/AddRtsAgent";
import { RootState } from "../../../../app/features/store/store";
import {
  AddRtsRequest,
  RouteCheckoutRequest,
} from "../../../../app/models/requestModels/RtsRequestAdminPanel";
import { Client } from "../../../../app/models/responseModels/clientsResponse";
import { StoreResponse } from "../../../../app/models/responseModels/storeResponse";
import { UserDataResponse } from "../../../../app/models/responseModels/userDataUiResponse";
import FormikTextField from "../../../../components/common/formikFields/FormikTextField";
import Loader from "../../../../components/common/loader/Loader";
import SubmitModalWithFormik from "../../../../components/common/modalPopup/SubmitModalWithFormik";
import { MultiRtsData } from "../../DdTypes";

const today = dayjs();
const dateBeforeThreeMonths = dayjs().subtract(3, "month");
interface AddRouteCheckoutModalProps {
  clientIdArg: number;
  clientNameArg: string;
  closeRouteCheckoutModal: CallableFunction;
  onCompleted: CallableFunction;
}

function AddRouteCheckoutFormModel(
  userId: string,
  operationDate: string,
  comment: string,
  email: string,
  storeId: number
): RouteCheckoutRequest {
  return {
    userId: userId,
    email: email,
    operationDate: operationDate,
    comment: comment,
    storeId: storeId,
  };
}

const AddRouteCheckoutModal = ({
  clientIdArg,
  clientNameArg,
  closeRouteCheckoutModal,
  onCompleted,
}: AddRouteCheckoutModalProps) => {
  const initialValues: any = {
    userId: "",
    email: "",
    comment: "",
  };
  const { isFdpLoading, fdpListByClient } = useSelector(
    (state: RootState) => state.fdp
  );

  const [selectedRadio, setSelectedRadio] = useState("barcode");
  const [storeData, setStoreData] = useState<StoreResponse[]>();
  const { rtsEventTypes } = useSelector((state: RootState) => state.rts);
  const [driverData, setDriverData] = useState<UserDataResponse[]>();
  const [associatedEmailData, setAssociatedEmailData] = useState<Client[]>();
  const [serviceLoading, setServiceLoading] = useState<boolean>(false);
  const [dateField, setDateField] = useState<dayjs.Dayjs>(today);

  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [selectedFileName, setSelectedFileName] = useState<string>("");

  const [rtsPackageData, setRtsPackageData] = useState<MultiRtsData[]>([
    {
      type: "barcode",
      barcode: "",
      reasonId: 0,
    },
  ]);

  async function handleSubmit(values: RouteCheckoutRequest) {
    console.log("values", values);
    try {
      const addRcDetails = AddRouteCheckoutFormModel(
        values.userId,
        !Number.isNaN(dateField)
          ? dateField.format("YYYY-MM-DD")
          : today.format("YYYY-MM-DD"),
        values.comment,
        values.email,
        values.storeId
      );

      const response = await FdpAgent.saveRouteCheckout(addRcDetails).then(
        async (resp) => {
          if (resp.isSuccess) {
            toast.success(resp.message);
            await submitRtsData(values);
          } else {
            toast.warn(resp.message);
          }
        }
      );
    } catch (error) {
      toast.error("Some error occurred.");
    }
  }

  function sanitizeRtsData(): MultiRtsData[] {
    console.log("Rts Data", rtsPackageData);

    var sanitizeData: MultiRtsData[] = rtsPackageData.filter((singleData) => {
      return (
        singleData.reasonId &&
        singleData.reasonId !== 0 &&
        ((singleData.type == "barcode" &&
          singleData.barcode &&
          singleData.barcode != "") ||
          (singleData.type == "image" &&
            singleData.image &&
            singleData.image != ""))
      );
    });

    sanitizeData.forEach((data) => {
      if (data.type == "barcode") {
        data.image = undefined;
      }
      if (data.type == "image") {
        data.barcode = undefined;
      }
    });
    console.log("filtered data", sanitizeData);
    return sanitizeData;
  }

  async function submitRtsData(values: RouteCheckoutRequest) {
    var rtsData: MultiRtsData[] = sanitizeRtsData();
    // upload all images first and then set the rtsData with image Url
    var updatedRtsData = await uploadImages(rtsData);
    // set multiple rts data and send the request to server.

    const newRtsDetails: AddRtsRequest[] = updatedRtsData.map((data) => {
      return {
        userId: values.userId,
        storeId: values.storeId,
        eventTypeId: data.reasonId,
        action: "open",
        latitude: storeData
          ? storeData.filter((store) => store.id === values.storeId)[0].latitude
          : "",
        longitude: storeData
          ? storeData.filter((store) => store.id === values.storeId)[0]
              .longitude
          : "",
        operationDate: !Number.isNaN(dateField)
          ? dateField.format("YYYY-MM-DD")
          : today.format("YYYY-MM-DD"),
        scanLocalTime: format(new Date(), "yyyy-MM-dd'T'HH:mm:ss"),
        scanTimeInGmt:
          format(utcToZonedTime(new Date(), "UTC"), "yyyy-MM-dd'T'HH:mm:ss") +
          "Z",
        scanType: "system",
        barcode: data.type == "barcode" ? data.barcode : undefined,
        imageUrl: data.type == "image" ? data.image : undefined,
      };
    });

    // Now hit the API to store the RTS data
    await submitMultipleRtsData(newRtsDetails);
  }

  async function submitMultipleRtsData(newRtsDetails: AddRtsRequest[]) {
    try {
      console.log("MultiData ", newRtsDetails);
      if (newRtsDetails && newRtsDetails.length > 0) {
        const response = await DedicatedDeliveryAgent.persistMultiRtsData(
          newRtsDetails
        ).then((resp) => {
          if (resp.isSuccess) {
            toast.success("All RTS packages have been added successfully.");
          } else if (resp.data?.failureInsertions) {
            resp.data.failureInsertions.forEach((failure) => {
              toast.warn(failure);
            });
          }
        });
      }
    } catch (err: any) {
      toast.error(err);
    }
  }

  async function uploadImages(
    rtsData: MultiRtsData[]
  ): Promise<MultiRtsData[]> {
    await Promise.all(
      rtsData.map(async (data) => {
        if (data.type == "image" && data.image) {
          const files: string[] = [data.image];
          try {
            const resp = await AddRtsAgent.uploadImage({ files });
            data.image = resp?.imageStatus[0]?.accessUrl;
          } catch (err) {
            toast.error("Error while uploading the image.");
          }
        }
      })
    );
    return rtsData;
  }

  async function fetchDriversByFdp(fdpId: number) {
    try {
      const response = await FdpAgent.getDriversByFdp(fdpId);
      return response.data;
    } catch (error) {
      // Handle errors here, e.g., log them or throw a custom error
      console.error("Error fetching drivers by FDP:", error);
      throw error; // Rethrow the error to be handled by the caller if necessary
    }
  }
  async function fetchEmailDetailsByFdpId(fdpId: number) {
    try {
      const response = await FdpAgent.fetchFdpAssociatedClients(fdpId);
      return response.data;
    } catch (error) {
      // Handle errors here, e.g., log them or throw a custom error
      console.error("Error fetching emails by FDP:", error);
      throw error; // Rethrow the error to be handled by the caller if necessary
    }
  }

  async function fetchStoresByFdp(fdpId: number) {
    try {
      const response = await FdpAgent.getStoresByFdpId(fdpId, clientIdArg);
      return response.data;
    } catch (error) {
      // Handle errors here, e.g., log them or throw a custom error
      console.error("Error fetching stores by FDP:", error);
      throw error; // Rethrow the error to be handled by the caller if necessary
    }
  }
  // Function to handle radio button change
  const handleRadioChange = (index: number, newType: string) => {
    setRtsPackageData((prevData) =>
      prevData.map((data, i) =>
        i === index ? { ...data, type: newType } : data
      )
    );
  };

  // Function to handle other data changes
  const handleDataChange = (
    index: number,
    field: string,
    value: string | number
  ) => {
    setRtsPackageData((prevData) =>
      prevData.map((data, i) =>
        i === index ? { ...data, [field]: value } : data
      )
    );
  };
  function addRtsPackagePlaceholder(event: any): void {
    setRtsPackageData((prevRtsPackageData) => [
      ...prevRtsPackageData,
      {
        type: "barcode",
        barcode: "",
        reasonId: 0,
      },
    ]);
  }

  const deleteRtsPackage = (index: number) => {
    setRtsPackageData((prevRtsPackageData) =>
      prevRtsPackageData.filter((_, i) => i !== index)
    );
  };

  const validationSchema = Yup.object().shape({
    userId: Yup.string()
      .required("Driver is required")
      .test(
        "driver-is-not-empty",
        "Driver cannot be blank. ",
        (value) => value !== ""
      ),
    storeId: Yup.number()
      .required("Store is required")
      .test(
        "store-is-not-empty",
        "Store cannot be blank. ",
        (value) => value !== 0
      ),
    email: Yup.string()
      .required("Email is required")
      .test(
        "email-is-not-empty",
        "Email cannot be blank. ",
        (value) => value !== ""
      ),
    comment: Yup.string()
      .required("Comment is required")
      .test(
        "comment-is-not-empty",
        "Comment cannot be blank. ",
        (value) => value !== ""
      ),
  });
  return (
    <>
      <Loader isLoading={isFdpLoading || serviceLoading} />
      <Formik
        initialValues={{ ...initialValues }}
        validationSchema={validationSchema}
        onSubmit={(values: any, { setSubmitting }) => {
          setSubmitting(true);
          handleSubmit(values);
          setSubmitting(false);
        }}
      >
        <SubmitModalWithFormik
          title={"Add New " + clientNameArg + " Route Checkout"}
          closeSubmitModal={closeRouteCheckoutModal}
          childErrorMessage={""}
          allowSubmit={false}
          size="lg"
          isLoading={false}
          submitButtonName="Add"
          closeModalAfterSubmit={true}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Form>
              <Grid container rowSpacing={2} columnSpacing={2}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormikTextField
                    margin="normal"
                    id="fdpId"
                    name="fdpId"
                    label="FDP"
                    size="small"
                    fullWidth
                    variant={"outlined"}
                    required
                    select
                    SelectProps={{
                      MenuProps: { PaperProps: { style: { maxHeight: 150 } } },
                    }}
                    onChange={(e: any) => {
                      setDriverData(undefined);
                      setStoreData(undefined);
                      setServiceLoading(true);
                      fetchDriversByFdp(e.target.value).then((drivers) => {
                        setDriverData(drivers);
                      });
                      fetchStoresByFdp(e.target.value).then((stores) => {
                        setStoreData(stores);
                      });
                      fetchEmailDetailsByFdpId(e.target.value).then(
                        (details) => {
                          setAssociatedEmailData(details);
                        }
                      );
                      setServiceLoading(false);
                    }}
                  >
                    {fdpListByClient ? (
                      fdpListByClient.map((fdp, index) => (
                        <MenuItem key={index} value={fdp.id}>
                          {fdp.companyName}
                        </MenuItem>
                      ))
                    ) : (
                      <div></div>
                    )}
                  </FormikTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormikTextField
                    margin="normal"
                    id="userId"
                    name="userId"
                    label="Driver"
                    size="small"
                    fullWidth
                    variant={"outlined"}
                    required
                    select
                    SelectProps={{
                      MenuProps: { PaperProps: { style: { maxHeight: 150 } } },
                    }}
                  >
                    {driverData ? (
                      driverData.map((driver, index) => (
                        <MenuItem key={index} value={driver.id}>
                          {driver.firstName} {driver.lastName}
                        </MenuItem>
                      ))
                    ) : (
                      <div></div>
                    )}
                  </FormikTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormikTextField
                    margin="normal"
                    id="storeId"
                    name="storeId"
                    label="Store"
                    size="small"
                    fullWidth
                    variant={"outlined"}
                    required
                    select
                    SelectProps={{
                      MenuProps: { PaperProps: { style: { maxHeight: 150 } } },
                    }}
                  >
                    {storeData &&
                      storeData.map((store, index) => (
                        <MenuItem key={index} value={store.id}>
                          {store.storeId}
                        </MenuItem>
                      ))}
                  </FormikTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormikTextField
                    margin="normal"
                    id="email"
                    name="email"
                    label="Client Email"
                    size="small"
                    fullWidth
                    variant={"outlined"}
                    required
                    select
                    SelectProps={{
                      MenuProps: { PaperProps: { style: { maxHeight: 150 } } },
                    }}
                  >
                    {associatedEmailData ? (
                      associatedEmailData
                        .filter((data) => +data.id == clientIdArg)
                        .map((assoc, index) =>
                          assoc.driverEmailIds.map((email, index) => (
                            <MenuItem key={index} value={email}>
                              {email}
                            </MenuItem>
                          ))
                        )
                    ) : (
                      <div></div>
                    )}
                  </FormikTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <FormikTextField
                    margin="normal"
                    id="comment"
                    name="comment"
                    label="Comment"
                    size="small"
                    fullWidth
                    variant={"outlined"}
                    required
                  ></FormikTextField>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDatePicker
                      name="date"
                      label="Date"
                      value={dateField}
                      minDate={dateBeforeThreeMonths}
                      maxDate={today}
                      disableFuture
                      views={["year", "month", "day"]}
                      onChange={(newValue: any) => {
                        if (
                          newValue &&
                          newValue >= dateBeforeThreeMonths &&
                          newValue <= today
                        ) {
                          setDateField(newValue);
                        }
                      }}
                      slotProps={{
                        textField: {
                          "aria-readonly": true,
                        },
                      }}
                    />
                  </LocalizationProvider>
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Card>
                    <CardHeader subheader="Add RTS Packages" />
                    <CardContent>
                      {rtsPackageData.map((data, index) => (
                        <Box
                          key={index}
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <RadioGroup
                            value={data.type}
                            onChange={(e) =>
                              handleRadioChange(index, e.target.value)
                            }
                            sx={{ flexDirection: "row" }}
                          >
                            <FormControlLabel
                              value="barcode"
                              control={<Radio />}
                              label="Barcode"
                            />
                            <FormControlLabel
                              value="image"
                              control={<Radio />}
                              label="Image"
                            />
                          </RadioGroup>

                          {data.type === "barcode" && (
                            <FormikTextField
                              margin="normal"
                              id={`barcode-${index}`}
                              name={`barcode-${index}`}
                              label="Barcode"
                              size="small"
                              variant="outlined"
                              required
                              value={data.barcode || ""}
                              onChange={(e: any) =>
                                handleDataChange(
                                  index,
                                  "barcode",
                                  e.target.value
                                )
                              }
                              sx={{ minWidth: 300 }}
                            />
                          )}

                          {data.type === "image" && (
                            <>
                              <input
                                type="file"
                                style={{ display: "none" }}
                                id={`fileInput-${index}`}
                                onChange={(e) => {
                                  const file = e.target.files?.[0];
                                  if (file && file.type.startsWith("image/")) {
                                    const reader = new FileReader();
                                    reader.onloadend = () => {
                                      handleDataChange(
                                        index,
                                        "image",
                                        reader.result as string
                                      );
                                    };
                                    reader.readAsDataURL(file);
                                    handleDataChange(index, "image", file.name);
                                  }
                                }}
                              />
                              <label htmlFor={`fileInput-${index}`}>
                                <Button
                                  variant="contained"
                                  component="span"
                                  sx={{ minWidth: 200 }}
                                >
                                  Select Image File
                                </Button>
                              </label>
                              {data.image && <span>Selected</span>}
                            </>
                          )}

                          <FormikTextField
                            margin="normal"
                            id={`eventTypeId-${index}`}
                            name={`eventTypeId-${index}`}
                            label="Reason"
                            size="small"
                            variant="outlined"
                            required
                            select
                            value={data.reasonId || ""}
                            onChange={(e: any) =>
                              handleDataChange(
                                index,
                                "reasonId",
                                Number(e.target.value)
                              )
                            }
                            sx={{ minWidth: 300 }}
                            SelectProps={{
                              MenuProps: {
                                PaperProps: { style: { maxHeight: 150 } },
                              },
                            }}
                          >
                            {rtsEventTypes.map((eventType) => (
                              <MenuItem key={eventType.id} value={eventType.id}>
                                {eventType.eventDescription}
                              </MenuItem>
                            ))}
                          </FormikTextField>
                          <IconButton onClick={addRtsPackagePlaceholder}>
                            <AddCircleOutlineOutlined />
                          </IconButton>
                          {rtsPackageData.length > 1 && (
                            <IconButton onClick={() => deleteRtsPackage(index)}>
                              <Delete />
                            </IconButton>
                          )}
                        </Box>
                      ))}
                    </CardContent>
                  </Card>
                </Grid> */}
              </Grid>
            </Form>
          </Box>
        </SubmitModalWithFormik>
      </Formik>
    </>
  );
};

export default AddRouteCheckoutModal;
